import React from 'react'
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

class CustomCheckbox extends React.Component{

  render() {
    // const color = this.props.color || "primary"
    const {label, className, value, ...checkbox} = this.props

    return (
      <FormControlLabel
        control={
          <Checkbox
            {...checkbox}
          />
        }
        className={className}
        label={label}
      />
    )
  }
}

export default CustomCheckbox



// WEBPACK FOOTER //
// ./src/js/components/inputs/Checkbox.js